import { create } from "zustand";

export interface TripPresence {
  user_id: string;
  last_seen: number;
  presence_ref?: string;
}

interface PresenceState {
  activeUsers: TripPresence[];
  setActiveUsers: (users: TripPresence[]) => void;
  addUser: (user: TripPresence) => void;
  removeUser: (userId: string) => void;
}

const usePresenceStore = create<PresenceState>((set) => ({
  activeUsers: [],
  setActiveUsers: (users) => set({ activeUsers: users }),
  addUser: (user) =>
    set((state) => ({
      activeUsers: [
        ...state.activeUsers.filter((u) => u.user_id !== user.user_id),
        user,
      ],
    })),
  removeUser: (userId) =>
    set((state) => ({
      activeUsers: state.activeUsers.filter((user) => user.user_id !== userId),
    })),
}));

export default usePresenceStore;
